// style-in-JS in order to make portal-form pretty!
// This is also styling for Case Level

export default {
  wrapper: {
    FontFamily: '"lato", sans-serif',
  },
  header: {
    textAlign: 'center',
  },
  formHeaderWrapper: {
    borderBottom: '1px solid #d3d3d3',
    display: 'flex',
    alignItems: 'flex-end', 
    justifyContent: 'center',
    width: '100%',
    margin: 'auto',
  },
  menuChosenPathologist:{
    width: '100%',
  },
  
  pathologistMenuPTag: {
    fontFamily: '"roboto", sans-serif',
    padding: '1em',
    fontSize:'1.2em',
    float: 'left',
    textTransform: 'uppercase',
    fontWeight: '600',  
  },

  dropDownMenuPathologists: {
    marginTop: '1em',
    border: '1px solid lightgray',
    backgroundColor: 'white',
    borderRadius: '3px',
    float: 'left',
  },

  btnSave: {
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: "3px",
    boxShadow: "0 2px 3px -1px #ccc !important",
    color: "#777",
    cursor: "pointer",
    fontSize: "16px",
    letterSpacing: "0.6px",
    padding: "8px 40px",
    textTransform: "uppercase",
  },

  btnDisabled: {
    opacity: "0.3",
    cursor: "not-allowed",
  },

  iccrLogo: {
    height: '40px',
    width: 'auto',
    margin: '0.83em',
    alignSelf: 'center',
  },
  
  greyWrapper: {
    backgroundColor: '#ededed',
    fontFamily: 'sans-serif',
    padding: '40px',
    fontSize: '14px',
  },
  fieldset: {
    border: '0',
    padding: '0',
    margin: '0',
  },
  formSection: {
    marginBottom: '40px',
  },
  formSectionTitle: {
    color: '#333',
    fontWeight: '600',
    fontSize: '16px',
    textTransform: 'uppercase',
  },
  formRow: {
    display: 'flex',
    justifyContent: 'center',
  },
  formColLeft: {
    borderRight: '1px solid #d3d3d3',
    flexBasis: '50%',
    paddingRight: '5%',
  },
  formColRight: {
    flexBasis: '50%',
    paddingLeft: '5%',
  },
  bold: {fontWeight: 'bold'},
  paddingLeft: {paddingLeft: '20px'},
  paddingBottom: {paddingBottom: '30px'},

  radioGroupInline: {
    display: 'flex',
    maxWidth: '300px',
  },
  radioGroupInlineMax: {
    display: 'flex',
    maxWidth: '300px',
  },
  radioGroupInlineMaxChild: {
    marginRight: 'auto',
  },
  textField: {
    backgroundColor: '#fff',
    borderRadius: '3px',
    boxShadow: '0 2px 3px -1px #ccc',
    height: '40px',
    padding: '0 8px',
    transition: 'box-shadow 0.4s ease',
  },
  textArea: {
    backgroundColor: '#fff',
    borderRadius: '3px',
    boxShadow: '0 2px 3px -1px #ccc',
    padding: '0 8px 8px 8px',
    transition: 'box-shadow 0.4s ease',

    height: '100%',
    maxHeight: '120px',
    marginTop: '4px',
  },

  btnPlacement:{
    display: 'flex',
    alignItems: 'center',
  }
};
